import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { BsCheckAll } from "react-icons/bs";
import PrivacyPolicyComponent from "../../Components/PrivacyPolicy/PrivacyPolicyComponent";
import { GetLocalStorageParsed } from "../utils/page";
const PrivacyPolicy = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [loading, setLoading] = useState();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Header setLoginToken={setLoginToken} setLoading={setLoading} />
        <PrivacyPolicyComponent />
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;
